import gql from 'graphql-tag';
import { UserAllDataFragment } from '../fragments';

export default gql`
mutation updateUser (
    $id: ID!
    $name: String
    $email: String
    $telephone: String
    $default_billing_address: ID
    $default_shipping_address: ID
    $lyoness_card_number: String
) {
    updateUser (userData: {
        id: $id,
        name: $name,
        email: $email,
        telephone: $telephone,
        default_billing_address: $default_billing_address,
        default_shipping_address: $default_shipping_address,
        lyoness_card_number: $lyoness_card_number
    }) {
        ...UserAllDataFragment
    }
}
${UserAllDataFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/updateUser.ts